import {createApi} from '@reduxjs/toolkit/query/react';

import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from 'shared/config/model/urls';

import {IMessengerChat, IMessengerChatAdd, INotifyChannelEdit} from '../model/INotifyChannel';

import {notifyChannelApiOptions, notifyChannelEndpoints} from './notifyChannelEndpoints';

export const maxChatAPI = createApi({
    reducerPath: 'maxChatAPI',
    baseQuery: httpBaseQuery(),
    ...notifyChannelApiOptions,
    endpoints: notifyChannelEndpoints<IMessengerChat, IMessengerChatAdd, INotifyChannelEdit>({
        list: ApiUrls.MAX_CHATS,
        item: ApiUrls.MAX_CHAT,
        testNotify: ApiUrls.MAX_CHAT_TEST_NOTIFY,
    }),
});
